import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { requestType } from "../../types/common";
import { luckyUsersType } from "../../types/luckyUsers";
interface luckyUsersProp {
  luckyUsers: requestType<luckyUsersType>;
}
const initialState: luckyUsersProp = {
  luckyUsers: { loading: false },
};
export const luckyUserSlice = createSlice({
  name: "luckly",
  initialState,
  reducers: {
    setLoadingLucky(state, action: PayloadAction<boolean>) {
      state.luckyUsers.loading = action.payload;
    },
    setluckyUsers(state, action: PayloadAction<luckyUsersType>) {
      state.luckyUsers.loading = false;
      state.luckyUsers.data = action.payload;
    },
  },
});
export const luckyUserAction = luckyUserSlice.actions;
export default luckyUserSlice.reducer;
